export default __webpack_public_path__ + "static/media/CoinNoText.33beee5d.svg";